import axios from 'axios';
import i18n from '@/i18n';

export default {

  namespaced: true,

  state: {
    authenticated: false,
    user: null,
    changedLocale: false,
  },

  getters: {
    authenticated(state) {
      return state.authenticated;
    },

    user(state) {
      return state.user;
    },

    customer(state) {
      if (state.user) { return state.user.customer; }
      return null;
    },

    userLocale(state) {
      if (state.user) { return state.user.lang; }
      return null;
    },

    currency(state) {
      if (state.user) return state.user.customer.currency;
      return null;
    },

    vat(state) {
      if (state.user) return state.user.customer.vat;
      return null;
    },

    billingAddress(state) {
      if (state.user) { return state.user.customer.billing_address; }
      return null;
    },

    shippingAddresses(state) {
      if (state.user) { return state.user.customer.addresses.filter((address) => address.type === 'S'); }
      return null;
    },

    changedLocale(state) {
      return state.changedLocale;
    },

    isTaxable(state) {
      return state.user && state.user.customer ? state.user.customer.tax_rule.taxable : true;
    },
  },

  mutations: {
    SET_AUTHENTICATED(state, value) {
      state.authenticated = value;
    },

    SET_USER(state, value) {
      state.user = value;
    },

    CHANGE_LOCALE(state) {
      state.changedLocale = !state.changedLocale;
    },
  },

  actions: {
    async register({ dispatch }, credentials) {
      await axios.post('/register', credentials);

      return dispatch('me');
    },

    async signIn({ dispatch }, credentials) {
      await axios.get('/sanctum/csrf-cookie');
      await axios.post('/login', credentials);

      return dispatch('me');
    },

    async signOut({ dispatch }) {
      await axios.post('/logout');

      return dispatch('me');
    },

    me({ commit, dispatch, rootState }) {
      return axios.get('/api/user')
        .then(({ data }) => {
          commit('SET_AUTHENTICATED', true);
          commit('SET_USER', data);
          i18n.locale = data.lang;
          dispatch('cart/setUser', data.id, { root: true });
          dispatch('logUserAgent');
          return dispatch('changeLocale');
        }).catch(() => {
          i18n.locale = rootState.shop.lang;
          commit('SET_AUTHENTICATED', false);
          commit('SET_USER', null);
          return dispatch('changeLocale');
        });
    },

    auth({ commit }) {
      return axios.get('/api/user')
        .then(({ data }) => {
          commit('SET_USER', null);
          commit('SET_AUTHENTICATED', true);
          commit('SET_USER', data);
        }).catch(() => {
          commit('SET_AUTHENTICATED', false);
          commit('SET_USER', null);
        });
    },

    changeLocale({ commit, dispatch }) {
      axios.defaults.headers.common['Accept-Language'] = i18n.locale;
      const locale = {
        newLocale: i18n.locale,
      };
      return axios.put('/api/locales', locale).then(() => {
        commit('CHANGE_LOCALE');
      }).catch((error) => {
        const notification = {
          type: 'error',
          message: `${this.$t('notifications.changeLocale')}: ${error.message}`,
        };
        dispatch('notifications/add', notification, { root: true });
      });
    },

    async logUserAgent() {
      await axios.put('/api/user-agent', { user_agent: navigator.userAgent });
    },
  },
};
